import { render, staticRenderFns } from "./historyScore.vue?vue&type=template&id=45827743"
import script from "./historyScore.vue?vue&type=script&lang=js"
export * from "./historyScore.vue?vue&type=script&lang=js"
import style0 from "./historyScore.vue?vue&type=style&index=0&id=45827743&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports